import { ADMIN_ROLES } from "../auth";
import { routes as taskActionSubRoutes } from "../task/taskActions/routes";

export const routes = {
    "/taskManagement": {
        title: "Task Management",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name, ADMIN_ROLES.CLINICIAN.name],
        ...taskActionSubRoutes
    }
};
